module.exports = __webpack_public_path__ + "img/muted.bb447a75.svg";